import { TextField } from '@mui/material';

// Read-only field whose value is derived live from the rest of the form's
// dataCollection. Provide a `compute(dataCollection)` function on the field.
const TypeComputed = ({ dataCollection, field, size }) => {
  const value = field.compute ? field.compute(dataCollection || {}) : '';

  return (
    <TextField
      label={field.label}
      value={value ?? ''}
      size={size}
      fullWidth
      disabled
      InputProps={{ readOnly: true }}
    />
  );
};

export default TypeComputed;
